import { sylvanus } from '~/services/serviceInstances';

import {
  type DdeTable,
  mapDdeTable,
  type ServerDdeTableResponse,
} from './ddeTableTypes';

type CreateDdeTableRequest = {
  name: string;
};

export const createDdeTable = async (
  request: CreateDdeTableRequest,
): Promise<DdeTable> => {
  const response = await sylvanus.post<ServerDdeTableResponse>('/dde/tables', {
    name: request.name,
  });

  return mapDdeTable(response);
};
